import type { PatchOp } from "@defibrillator/preset-core";

function formatOp(op: PatchOp): string {
  switch (op.op) {
    case "set":
      return `${op.param} = ${op.value}`;
    case "modulate":
      return `mod[${op.slot}] ${op.source} → ${op.destination} (${op.amount})`;
    case "unmodulate":
      return `unmod[${op.slot}]`;
    case "lfo_shape":
      return `lfo ${op.index} shape ${op.shape}`;
    case "wavetable":
      return `wt osc${op.osc} ${op.generator.kind}`;
    case "meta":
      return `meta ${op.presetName} / ${op.style}`;
    default:
      return JSON.stringify(op);
  }
}

export function PatchOpList({ ops }: { ops: PatchOp[] }) {
  if (ops.length === 0) {
    return <p style={{ color: "var(--ink-muted)", margin: 0 }}>No ops yet.</p>;
  }
  return (
    <ul className="ops">
      {ops.map((op, i) => (
        <li key={`${op.op}-${i}`}>
          <strong>{op.op}</strong> {formatOp(op)}
        </li>
      ))}
    </ul>
  );
}
